<div class="upload-container">
  <label class="upload-label">Image<span class="required">*</span></label>
  
  <div class="upload-area" 
       [class.drag-over]="isDragOver"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)"
       [class.selectedFile]="imagePreview">
    
    <div class="upload-content" *ngIf="!imagePreview && !imageUrl" (click)="onBrowseClick()">
      <div class="upload-icon">
        <div class="icon-circle">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.2109 13.1152V16.4486C18.2109 16.8906 18.0353 17.3145 17.7228 17.6271C17.4102 17.9396 16.9863 18.1152 16.5443 18.1152H4.8776C4.43558 18.1152 4.01165 17.9396 3.69909 17.6271C3.38653 17.3145 3.21094 16.8906 3.21094 16.4486V13.1152" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.8802 7.2819L10.7135 3.11523L6.54688 7.2819" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.7109 3.11523V13.1152" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        </div>
      </div>
      
      <div class="upload-text">
        <p class="drag-text">Drag & drop your files here or <span class="upload-text-bold">browse</span> to upload</p>
      </div>
      
      <div class="upload-info">
        <span class="file-formats">{{ acceptedFormats }}</span>
        <span class="file-size">Max file size - {{ maxFileSize }}</span>
      </div>
    </div>

    <div class="file-display" *ngIf="imagePreview || imageUrl">
      <div class="file-info">
        <div class="">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8.50261" cy="8.50065" r="6.66667" fill="#079271"/>
            <path d="M10.4016 7.52859L7.75563 10.1756L6.4311 8.85211" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        </div>
        <div class="file-details">
          <p class="file-name">{{ selectedFileName || imageUrl }}</p>
          
        </div>
      </div>
      <button type="button" class="remove-btn" (click)="onRemoveImage($event)">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.96973 0.969727C9.26262 0.676854 9.73739 0.67684 10.0303 0.969727C10.3231 1.26262 10.3231 1.73741 10.0303 2.03027L6.56055 5.5L10.0303 8.96973C10.3231 9.26262 10.3231 9.73741 10.0303 10.0303C9.73741 10.3231 9.26263 10.3231 8.96973 10.0303L5.5 6.56055L2.03027 10.0303C1.73741 10.3231 1.26263 10.3231 0.969727 10.0303C0.676833 9.73738 0.676833 9.26262 0.969727 8.96973L4.43945 5.5L0.969727 2.03027C0.676833 1.73738 0.676833 1.26262 0.969727 0.969727C1.26262 0.676854 1.73739 0.67684 2.03027 0.969727L5.5 4.43945L8.96973 0.969727Z" fill="#A7ABB3"/>
          </svg>
          
      </button>
    </div>
  </div>

  <input 
    type="file" 
    id="file-input" 
    accept=".png,.jpg,.jpeg"
    (change)="onFileSelected($event)"
    style="display: none;">

  <!-- Validation Error Display -->
  <div class="validation-error" *ngIf="validationError">
    {{ validationError }}
  </div>
</div>
